import { APICfg } from 'services/api/api'
import { APILinkedProduct, WithId } from 'types/common'
import { FacetFilterGroup } from 'types/form'

export type FacetCategory =
  | 'tag'
  | 'productFilter'
  | 'filterTag'
  | 'group'
  | 'pricing'

export type APIFacet = WithId & {
  code: string
  description: string
  products: APILinkedProduct[]
}

export type Facet = APIFacet & {
  category: FacetCategory
  filterGroup?: FacetFilterGroup
}

export type TagFacet = Facet & {
  tagName: string
}

export type FilterFacet = Facet & {
  filterGroup: string
  filterName: string
  isTag: boolean
}

export type GroupFacet = Facet & {
  productClusterCode: string
}

export type PricingFacetType = 'perItem' | 'perPerson'

export type PricingFacet = Facet & {
  pricingType: PricingFacetType
}

export type FacetToAPI = Omit<APIFacet, 'products'>

export type AnyFacet = TagFacet & FilterFacet & PricingFacet & GroupFacet

export const parseFacet = (f: APIFacet): Facet => {
  const { code, ...rest } = f

  return {
    ...rest,
    code,
    ...JSON.parse(code),
  }
}

export const writeFacet = (f: AnyFacet): FacetToAPI => {
  // products and code are destructured because they DON'T have to be stringyfied
  const { id, description, products, code, ...rest } = f

  return {
    id,
    description,
    code: JSON.stringify(rest),
  }
}

const apiCfg: APICfg = {
  endpoint: 'facets',
  parse: (res: APIFacet): Facet => parseFacet(res),
  write: async (req: AnyFacet): Promise<FacetToAPI> => writeFacet(req),
}

export default apiCfg
